import styled from 'styled-components';

export const Entries = styled.div`
  font-family: 'Roboto';

  .btn-full {
    padding: 0px 3px;
    border-radius: 2px;
    border: 1px solid #838383;
  }

  .sold-input {
    width: 50%;
    max-width: 200px;
  }
`;
